<template>
    <v-dialog v-model="dialogAbierto" scrollable :fullscreen="$vuetify.breakpoint.xsOnly" max-width="60%">
        <v-card v-if="inscripcion && inscripcion.id">
            <v-card-title>
                <span class="headline">Ver Inscripción {{ inscripcion.id }} </span>
            </v-card-title>

            <v-card-text>
                <v-container elevation-3 py-3 px-1>
                    <v-layout row wrap>
                        <v-flex xs12 mb-3>
                            <h3 class="headline ">{{ (inscripcion.personas.length > 1 ? 'Equipo' : 'Participante') }}</h3>
                            <span class="subheading">
                                {{ inscripcion.personas.length > 1 ? inscripcion.nombre : inscripcion.personas[0].nombre + ' '
                                    + inscripcion.personas[0].apellido + ' (' + inscripcion.personas[0].documento + ')' }}
                            </span>
                            <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs6 sm6 md4> 
                            <h3 class="subheading  font-weight-medium ">Modalidad</h3>
                            <span>
                                {{ inscripcion.modalidad.nombre }}
                            </span>
                        </v-flex>

                        <v-flex xs6 sm6 md4>
                            <h3 class="subheading font-weight-medium">Categoria</h3>
                            <span>
                                {{ inscripcion.categoria }}
                            </span>
                        </v-flex>



                        <v-flex xs6 sm6 md4>
                            <h3 class="subheading font-weight-medium">Fecha Inscripción</h3>
                            <span>
                                {{ inscripcion.created_at | formatDate }}
                            </span>
                        </v-flex>


                        <v-flex xs6 sm6 md4>
                            <h3 class="subheading font-weight-medium">Ultima Modificación</h3>
                            <span>
                                {{ inscripcion.updated_at | formatDate }}
                            </span>
                        </v-flex>


                        <v-flex xs12 sm6 md4>
                            <h3 class="subheading font-weight-medium">Estado</h3>
                            <span>
                                <LabelEstado :state="inscripcion.state"></LabelEstado>
                            </span>
                        </v-flex>


                        <v-flex xs12 sm6 md4 v-if="inscripcion.numero">
                            <h3 class="subheading font-weight-medium">Nro / ChipId</h3>
                            <span>
                               
                                <v-btn depressed small :color="'#fedfb3'">
                                    {{ inscripcion.numero }} / {{ inscripcion.chip_id }}
                                </v-btn>
                            </span>
                        </v-flex>

                    </v-layout>
                </v-container>


                <v-tabs v-model="model" slider-color="black">
                    <v-tab :key="'persona_tab'" :href="`#tab-personas`">
                        Datos Personales
                    </v-tab>
                    <v-tab :key="'pagos_tab'" :href="`#tab-pagos`">
                        Pagos
                    </v-tab>
                    
                     
                </v-tabs>

                <v-tabs-items v-model="model">
                    <v-tab-item :key="'persona'" :value="`tab-personas`">
                        <v-container>
                            <v-layout v-for="(persona, index) in inscripcion.personas" :key="persona.id || index" row wrap>
                                
                                <v-flex xs12 v-if="inscripcion.personas.length > 1">
                                    <h3 class="headline font-weight-medium ">Participante {{ index + 1 }}</h3>                                    
                                </v-flex>

                                <v-flex v-for="key in Object.keys(persona).filter(item => ['deslinde','campo_custom_values', 'tiene_deslinde_firmado'].indexOf(item) == -1 ) " :key="key" xs6 sm6 md4 mt-3>

                                    <h3 class="subheading  font-weight-medium text-capitalize">{{key.replace('_', ' ')}}</h3>
                                    
                                    <span>
                                        {{ persona[key] }}
                                    </span>

                                </v-flex>
                                
                                <v-flex xs12 v-if="persona.tiene_deslinde_firmado">
                                    <h4 class="headline font-weight-medium ">Deslinde</h4>
                                    <v-btn v-if="!persona.download_url" :loading="loadingDeslinde" color="primary" @click="verDeslinde(persona)">Ver Deslinde</v-btn>

                                    <div v-if="persona.deslinde && persona.deslinde.download_url">
                                       <a :href="persona.deslinde.download_url" target="_blank">Descargar Deslinde</a>
                                         
                                        <h4 class=" ">Vista Previa</h4>
                                        <PDFViewer
                                            :source="persona.deslinde.download_url "
                                            style="height: 600px; width: 100%"
                                            :controls="[]"           
                                            :loading-text="'Cargando Deslinde...'"
                                            :rendering-text="'Renderizando Deslinde...'"    
                                            @loading-failed="onPdfLoadFailed"                                
                                        />
                                        <div v-if="persona.deslinde.status == 'APPROVED' "  >
                                            <v-alert type="success" outlined v-show="true">
                                               Deslinde Aprobado
                                            </v-alert>
                                        </div>
                                        <div v-if="persona.deslinde.status == 'REJECTED' "  >
                                            <v-alert type="warning" outlined v-show="true">
                                               Deslinde Rechazado
                                            </v-alert>
                                            <v-alert type="warning" outlined v-show="true">
                                                <p>La firma del deslinde fue rechazada, el participante puede volver a firmarla en la siguiente url:</p>

                                                <p>
                                                    {{signUrl}}{{persona.deslinde.access_token}}
                                                </p>

                                            </v-alert>

                                        </div>
                                        <div v-if="persona.deslinde.status == 'PENDING' "  style="text-align: right;" >
                                            <v-btn :loading="loadingValidation" dark color="warning" @click="rechazarDeslinde(persona, persona.deslinde.id)">
                                                <v-icon left>close</v-icon> Rechazar Deslinde
                                            </v-btn>
                                            <v-btn :loading="loadingValidation"  dark color="green" @click="aprobarDeslinde(persona, persona.deslinde.id)">
                                                <v-icon left>check</v-icon> Aprobar el Deslinde
                                            </v-btn>
                                        </div>
                                    </div>
                                    
                                </v-flex>
                             
                               <v-flex xs12 >
                                    <h3 class="headline font-weight-medium">Datos Adicionales</h3>                                    
                                </v-flex>

                                <v-flex v-for="(respuesta, idx) in respuestasAgrupadas(persona)" :key="idx" xs6 sm6 md4 mt-3>
                                    <h3 class="subheading  font-weight-medium text-capitalize">{{respuesta.label}}</h3>
                                    <span>
                                        {{ respuesta.value }}
                                    </span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>

                    <v-tab-item :key="'pagos'" :value="`tab-pagos`">
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <h3 class="headline font-weight-medium mb-2">Comprobante de Pago</h3>
                                    <v-divider class="mb-3"></v-divider>
                                </v-flex>

                                <v-flex xs12 class="mb-4">
                                    <v-card flat class="grey lighten-4 pa-4" style="border-left: 4px solid #666;">
                                        <div class="subheading font-weight-medium grey--text text--darken-2 mb-2">Pago expirado</div>
                                        <p class="body-2 grey--text text--darken-1 mb-3" style="max-width: 560px;">
                                            Esta inscripción venció sin comprobante. Podés reactivarla para dar un nuevo plazo y que el usuario pueda subir el comprobante.
                                        </p>
                                        <v-btn
                                            :loading="loadingReactivar"
                                            color="primary"
                                            depressed
                                            @click="reactivarInscripcion"
                                        >
                                            <v-icon left small>refresh</v-icon>
                                            Reactivar inscripción
                                        </v-btn>
                                        <template v-if="linkComprobante">
                                            <v-divider class="my-4"></v-divider>
                                            <div class="caption grey--text text--darken-2 mb-1">Link para que el usuario cargue el comprobante</div>
                                            <v-layout row wrap align-center>
                                                <v-flex class="pr-2" style="min-width: 0;">
                                                    <input
                                                        :value="linkComprobante"
                                                        readonly
                                                        type="text"
                                                        class="body-2 pa-2"
                                                        style="width:100%;background:#fff;border:1px solid #e0e0e0;border-radius:4px;font-family:monospace;font-size:13px;"
                                                    />
                                                </v-flex>
                                                <v-flex shrink>
                                                    <v-btn small depressed color="primary" @click="copiarLinkComprobante">
                                                        <v-icon left small>content_copy</v-icon>
                                                        Copiar
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </template>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <h3 class="subheading font-weight-medium">Estado</h3>
                                    <LabelEstado :state="inscripcion.state"></LabelEstado>
                                </v-flex>

                                <v-flex xs12 v-if="!hasPaymentReceipt">
                                    <v-alert type="info" outlined>
                                        No se ha subido un comprobante de pago para esta inscripción.
                                    </v-alert>
                                </v-flex>

                                <template v-if="hasPaymentReceipt">
                                    <v-flex xs12 sm6 md4 v-if="inscripcion.payment_receipt_uploaded_at">
                                        <h3 class="subheading font-weight-medium">Fecha Carga</h3>
                                        <span>{{ inscripcion.payment_receipt_uploaded_at | formatDate }}</span>
                                    </v-flex>

                                    <v-flex xs12 sm6 md4 v-if="inscripcion.payment_receipt_size">
                                        <h3 class="subheading font-weight-medium">Tamaño</h3>
                                        <span>{{ (inscripcion.payment_receipt_size/1024).toFixed(1) }} KB</span>
                                    </v-flex>

                                    <v-flex xs12 class="mt-4">
                                        <v-btn :href="paymentReceiptUrl" target="_blank" color="primary" small depressed>
                                            Descargar Comprobante
                                        </v-btn>
                                    </v-flex>

                                    <v-flex xs12 class="mt-4" v-if="paymentReceiptIsImage">
                                        <h3 class="subheading font-weight-medium mb-2">Vista Previa (Imagen)</h3>
                                        <v-img :src="paymentReceiptUrl" max-width="500" contain></v-img>
                                    </v-flex>

                                    <v-flex xs12 class="mt-4" v-else-if="paymentReceiptIsPdf">
                                        <h3 class="subheading font-weight-medium mb-2">Vista Previa (PDF)</h3>
                                        <iframe
                                            :src="paymentReceiptUrl"
                                            style="width:100%;height:600px;border:1px solid #ccc;border-radius:4px;"
                                        ></iframe>
                                    </v-flex>

                                    <v-flex xs12 v-else-if="hasPaymentReceipt">
                                        <v-alert type="warning" outlined>
                                            No se puede previsualizar este tipo de archivo ({{ inscripcion.payment_receipt_mime }}).
                                        </v-alert>
                                    </v-flex>
                                </template>

                                <v-flex xs12 class="mt-4" v-if="hasPaymentReceipt || inscripcion.state === 'pago_pendiente'">
                                    <v-divider class="mb-3"></v-divider>
                                    <h3 class="subheading font-weight-medium mb-2">Cambiar Estado</h3>
                                    <v-layout row wrap align-center>
                                        <v-flex xs12 sm8 md6>
                                            <v-select
                                                v-model="selectedState"
                                                :items="availableStates"
                                                item-text="text"
                                                item-value="value"
                                                label="Seleccionar nuevo estado"
                                                outlined
                                                dense
                                                :disabled="loadingPaymentValidation"
                                            ></v-select>
                                        </v-flex>

                                        <v-flex xs6 pa-2>
                                            <v-text-field v-model="reason"
                                                label="Razon de cambio de estado (opcional)">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm4 md6 class="pl-2">
                                            <v-btn 
                                                :loading="loadingPaymentValidation" 
                                                color="primary" 
                                                depressed 
                                                @click="changeState"
                                                :disabled="!selectedState || selectedState.toLowerCase() === (inscripcion.state || '').toLowerCase()"
                                            >
                                                <v-icon left small>swap_horiz</v-icon>
                                                Cambiar Estado
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>

                </v-tabs-items>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary  " @click="cerrarDialog">Cerrar</v-btn>
            </v-card-actions>
        </v-card>



    </v-dialog>
</template>

<script>
import api from "../../../api/inscripcion";
import LabelEstado from "../../common/LabelEstado.vue";
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'

 export default {
    components: { LabelEstado: LabelEstado , PDFViewer: PDFViewer},
    data() {
        return {
            model: "tab-personas",
            dialogAbierto: false,
            inscripcion: {},
            loadingDeslinde: false,
            loadingValidation: false,
            signUrl : process.env.VUE_APP_HOST_URL  + '/#/firmar-deslinde/',
            selectedState: null,
            loadingPaymentValidation: false,
            reason: '',
            loadingReactivar: false,
            states: [
                { text: 'Pago en revisión', value: 'PAGO_EN_REVISION' },
                { text: 'Pago realizado', value: 'PAGO_REALIZADO' },
                { text: 'Pago expirado', value: 'PAGO_EXPIRADO' },
                { text: 'Pago rechazado', value: 'PAGO_RECHAZADO' },
                { text: 'Paga en carrera', value: 'PAGA_EN_CARRERA' },
            ]
        };
    },
    computed: {
        baseUrl() {return process.env.VUE_APP_HOST_URL + '/files/'},
        hasPaymentReceipt() {
            return !!this.inscripcion.payment_receipt_path || !!this.inscripcion.payment_receipt_url;
        },
        availableStates() {
            const currentState = this.inscripcion.state ? this.inscripcion.state.toLowerCase() : '';
            if (currentState === 'pago_pendiente') {
                return this.states;
            }
            if (currentState === 'pago_realizado') {
                return this.states.filter(state => state.value !== 'PAGA_EN_CARRERA');
            }
            return this.states.filter(state => state.value !== 'PAGA_EN_CARRERA');
        },
        paymentReceiptIsImage() {
            if (!this.hasPaymentReceipt) return false;
            const mime = this.inscripcion.payment_receipt_mime || '';
            return mime.indexOf('image/') === 0;
        },
        paymentReceiptIsPdf() {
            if (!this.hasPaymentReceipt) return false;
            const mime = this.inscripcion.payment_receipt_mime || '';
            const path = (this.inscripcion.payment_receipt_path || '').toLowerCase();
            return mime === 'application/pdf' || path.endsWith('.pdf');
        },
        paymentReceiptUrl() {
            return this.inscripcion.payment_receipt_url;
        },
        linkComprobante() {
            if (!this.inscripcion.personas || !this.inscripcion.personas[0] || !this.inscripcion.personas[0].access_token) return '';
            return (process.env.VUE_APP_HOST_URL || '') + '/#/comprobante/' + this.inscripcion.personas[0].access_token;
        },
        isPagoExpirado() {
            return (this.inscripcion.state || '').toLowerCase() === 'pago_expirado';
        }
    },
    created() { },
    watch: {

    },
    mounted() { },
    methods: {
        abrirDialog(inscripcion) {
            api.getInscripcionById(inscripcion.id).then((response) => {
                this.inscripcion = response.results;
                this.dialogAbierto = true;
                this.selectedState = this.inscripcion.state ? this.inscripcion.state.toUpperCase() : null;
            }).catch(() => {
                this.dialogAbierto = false;
            });
        },
        changeState() {
            if (!this.selectedState) return;
            const currentStateLower = this.inscripcion.state ? this.inscripcion.state.toLowerCase() : '';
            const selectedStateLower = this.selectedState.toLowerCase();
            if (selectedStateLower === currentStateLower) return;
            
            this.loadingPaymentValidation = true;
            const stateToSend = selectedStateLower;
            api.changeInscriptionState(this.inscripcion.id,
                {
                    state: stateToSend,
                    reason: this.reason
                })
                .then((response) => {
                    if (response && response.results && response.results.state) {
                        this.inscripcion.state = response.results.state;
                        this.selectedState = response.results.state.toUpperCase();
                    } else {
                        this.inscripcion.state = stateToSend;
                        this.selectedState = this.selectedState;
                    }
                    this.loadingPaymentValidation = false;
                    this.$emit('state-changed', this.inscripcion);
            }).catch(() => {
                this.loadingPaymentValidation = false;
            });
        },
        cerrarDialog() {
            this.dialogAbierto = false;
        },
        verDeslinde(  persona) {
            this.loadingDeslinde = true;
            api.getDeslindeByPersonId(this.inscripcion.id,  persona.id).then((response) => {
                this.inscripcion.personas.find(item => item.id == persona.id).deslinde = response.results;
                this.loadingDeslinde = false;
            }).catch(() => {
                this.loadingDeslinde = false;
            });
        },
        rechazarDeslinde(persona, deslindeId) {
            this.loadingValidation = true;
            api.rechazarDeslinde( this.inscripcion.id, deslindeId).then(() => {
                this.loadingValidation = false;
                this.$set(this.inscripcion.personas.find(item => item.id == persona.id).deslinde, 'status', "REJECTED");
                this.verDeslinde(persona);
            }).catch(() => {
                this.loadingValidation = false;
            });
        },
        aprobarDeslinde(persona, deslindeId) {
            this.loadingValidation = true;
            api.aprobarDeslinde( this.inscripcion.id, deslindeId).then(() => {
                
                 this.loadingValidation = false;
                 this.$set(this.inscripcion.personas.find(item => item.id == persona.id).deslinde, 'status', "APPROVED");

            }).catch(() => {
                this.loadingValidation = false;
            });
        },
        reactivarInscripcion() {
            this.loadingReactivar = true;
            api.reactivarInscripcion(this.inscripcion.id)
                .then((response) => {
                    if (response && response.results) {
                        this.inscripcion = response.results;
                        this.selectedState = this.inscripcion.state ? this.inscripcion.state.toUpperCase() : null;
                        this.$emit('state-changed', this.inscripcion);
                        this.$emit('snackbar', { text: 'Inscripción reactivada. Nueva fecha de vencimiento asignada.', color: 'success' });
                    }
                    this.loadingReactivar = false;
                })
                .catch((error) => {
                    this.loadingReactivar = false;
                    const msg = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Error al reactivar la inscripción.';
                    this.$emit('snackbar', { text: msg, color: 'error' });
                });
        },
        copiarLinkComprobante() {
            const url = this.linkComprobante;
            if (!url) return;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(() => {
                    this.$emit('snackbar', { text: 'Link copiado al portapapeles', color: 'success' });
                }).catch(() => {
                    this.fallbackCopiarLink(url);
                });
            } else {
                this.fallbackCopiarLink(url);
            }
        },
        fallbackCopiarLink(url) {
            const input = document.createElement('input');
            input.value = url;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            try {
                document.execCommand('copy');
                this.$emit('snackbar', { text: 'Link copiado al portapapeles', color: 'success' });
            } catch (e) {
                this.$emit('snackbar', { text: 'No se pudo copiar; copiá el link manualmente', color: 'warning' });
            }
            document.body.removeChild(input);
        },
        onPdfLoadFailed() {
            this.$emit('snackbar', { text: 'No se pudo cargar el PDF del deslinde.', color: 'warning' });
        },
        respuestasAgrupadas(persona) {
            const valores = persona.campo_custom_values || [];
            const agrupado = {};
            valores.forEach((valor) => {
                if (!agrupado[valor.campo_custom_id]) {
                    agrupado[valor.campo_custom_id] = { label: valor.label, valores: [] };
                }
                agrupado[valor.campo_custom_id].valores.push(valor.value);
            });
            return Object.values(agrupado).map((item) => ({
                label: item.label,
                value: item.valores.join(', '),
            }));
        }
    }
};
</script>
